module.exports = __webpack_public_path__ + "static/media/18-iveco-mercedes.f95156a3.jpg";